import { useCallback, useMemo, useState } from "react"
import { TextMatch } from "shared/text"
import { GroupResult, useListGroup } from "interface/user/group"

export const useGroupConfigContainer = () => {
	const [searchWord, setSearchWord] = useState("")
	const [edittedGroupList, setEdittedGroupList] = useState<GroupResult[] | null>(null)

	const groupListState = useListGroup()
	const groupList = useMemo(() => {
		const groupList = edittedGroupList ?? groupListState.data?.list
		if (!groupList) return null
		if (searchWord === '') return groupList
		const match = new TextMatch(searchWord)
		return groupList.filter((group) => match.match(group.groupName))
	}, [edittedGroupList, groupListState, searchWord])

	const onAddGroup = useCallback(
		(group: GroupResult) => {
			const groupList = edittedGroupList ?? groupListState.data?.list
			if (!groupList) return
			setEdittedGroupList([...groupList, group])
		},
		[groupListState, edittedGroupList, setEdittedGroupList]
	)
	const onEditGroup = useCallback(
		(group: GroupResult) => {
			const groupList = edittedGroupList ?? groupListState.data?.list
			if (!groupList) return
			setEdittedGroupList(
				groupList.map((exist) => exist.groupId === group.groupId ? group : exist)
			)
		},
		[groupListState, edittedGroupList, setEdittedGroupList]
	)
	const onDeleteGroup = useCallback(
		(groupId: number) => {
			const groupList = edittedGroupList ?? groupListState.data?.list
			if (!groupList) return
			setEdittedGroupList(
				groupList.filter((exist) => exist.groupId === groupId ? false : true)
			)
		},
		[groupListState, edittedGroupList, setEdittedGroupList]
	)
	return useMemo(() => ({
    loading: groupListState.loading,
    error: groupListState.error,
    groupList,
    searchWord,
    setSearchWord,
		onAddGroup,
		onEditGroup,
		onDeleteGroup,
	}), [
		groupListState,
    groupList,
    searchWord,
    setSearchWord,
		onAddGroup,
		onEditGroup,
		onDeleteGroup,
	])
}